import { IStaticMessageConversationPayload } from '../../interfaces/agent-action-interfaces';

export const handleLink = (data: IStaticMessageConversationPayload) => {
  if (data.abstractMessage?.staticContent?.formatType === 'RichLink') {
    const linkItem = data.abstractMessage.staticContent.linkItem;
    return {
      label: linkItem.titleItem.title,
      url: linkItem.url,
    };
  }
  return undefined;
};
